exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-recent-projects-mdx": () => import("./../../../src/pages/recent-projects.mdx" /* webpackChunkName: "component---src-pages-recent-projects-mdx" */),
  "component---src-pages-thanks-mdx": () => import("./../../../src/pages/thanks.mdx" /* webpackChunkName: "component---src-pages-thanks-mdx" */)
}

